import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { TranslationModule } from 'src/app/i18n';
import { MaterialModule } from '../../modules/material/material.module';
import { CancelTokenComponent } from './cancel-token.component';



@NgModule({
  declarations: [
    CancelTokenComponent
  ],
  imports: [
    CommonModule,
    TranslationModule,
    MaterialModule,

  ],
  exports: [
    CancelTokenComponent
  ]
})
export class CancelTokenModule { }
